// ----------------------------------------------------------------------
// <copyright file="Izenda.Popup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module: CommonPopup Component
 *  <Popup visible={store.showPopup} onClosed={this.closed}>
   *    <Popup.Header title='Hello'>
   *      <Popup.ConfirmationButton type='accept'>Save</Popup.ConfirmationButton>
   *      <Popup.ConfirmationButton type='cancel'>Cancel</Popup.ConfirmationButton>
   *
 </Popup.Header>
   *    <Popup.Body>
   *       Popup body message
   *
 </Popup.Body>
   *    <Popup.Footer>
   *      <Popup.ConfirmationButton type='accept'>Save</Popup.ConfirmationButton>
   *      <Popup.ConfirmationButton type='cancel'>Cancel</Popup.ConfirmationButton>
   *
 </Popup.Footer>
   *
 </Popup>
 *
 *  @param type = accept | cancel
 *  closed: function(type){
 *    setVisible(false);
 *    ....
 *  }
 *
 */
!(function() {
  var React = require('react');
  var Button = require('share/components/controls/Izenda.Button');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var classnames = require('classnames');
  var Draggable = require('react-draggable');
  var Loading = require('share/components/controls/Izenda.Loading');

  const { assign, find, concat, isArray, isEmpty } = require('lodash/fp');

  var Popup = React.createClass({
    propsType: {
      visible: React.PropTypes.bool,
      onClosed: React.PropTypes.func,
      type: React.PropTypes.oneOf(['default', 'warning', 'error', 'info', 'none', 'confirm']),
      sizeClass: React.PropTypes.string,
      turnOffBodyDrag: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        visible: false,
        onClosed: null,
        autoClose: true,
        type: 'default',
        sizeClass: '',
        showLoading: false,
        turnOffBodyDrag: false
      };
    },

    getInitialState: function() {
      return {
        isVisible: !!this.props.visible,
        showLoading: this.props.showLoading
      };
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        isVisible: nextProps.visible,
        showLoading: nextProps.showLoading
      });
    },

    render: function() {
      var header = this.renderChildByType('Header', true);
      var body = this.renderChildByType('Body');
      var footer = this.renderChildByType('Footer', true);

      var finalHeader = header
        ? React.cloneElement(header, {
            onClosed: this.props.onClosed,
            onClosing: this.props.onClosing,
            autoClose: this.props.autoClose,
            hide: this.hide,
            type: this.props.type
          })
        : null;

      var finalFooter = footer
        ? React.cloneElement(footer, {
            onClosed: this.props.onClosed,
            onClosing: this.props.onClosing,
            autoClose: this.props.autoClose,
            hide: this.hide
          })
        : null;

      var modalClass = classnames('izenda-modal-dialog', this.props.sizeClass, this.props.containerClass);
      var style = assign(this.props.style, this.getStyle());
      var selectorHandle = this.props.turnOffBodyDrag || header ? '.modal-header' : '.modal-content';
      var contentClass = classnames(this.props.type, {
        'modal-content': true,
        u_curMove: !header && !this.props.turnOffBodyDrag
      });
      var backdropStyle = this.props.backdropStyle;

      return (
        <div>
          {this.state.isVisible && <div className='modal-backdrop in' style={backdropStyle}/>}

          <div tabIndex='-1' role='dialog' style={style} className={'modal fade ' + this.getShowingClass()}>
            <ScrollBox shouldInjectScrollCallbackToChild={false}>
              <Draggable handle={selectorHandle} bounds='.izenda' cancel='.btn, input, .izenda-Disable-move'>
                <div className={modalClass}>
                  <div className={contentClass}>
                    {finalHeader}
                    {body}
                    {finalFooter}
                    <Loading show={this.state.showLoading} />
                  </div>
                </div>
              </Draggable>
            </ScrollBox>
          </div>
        </div>
      );
    },

    renderChildByType: function(childType, optional) {
      var foundChild = find(function(child) {
        return child && child.type.displayName === childType;
      })(concat([], this.props.children));

      ensure(optional || foundChild, 'Popup must have %s', childType);

      return foundChild;
    },

    getShowingClass: function() {
      return this.state.isVisible ? 'in' : '';
    },

    getStyle: function() {
      return this.state.isVisible ? { display: 'block' } : { display: 'none' };
    },

    hide: function() {
      this.setState({
        isVisible: false
      });
    }
  });

  /**
   * [wrappPopupButton description]
   * @param  {[type]} btns [description]
   * @return {[type]}      [description]
   */
  function wrappPopupButton(btns) {
    var newBtns = [];
    var props = this.props;

    btns = isArray(btns) ? btns : [btns];
    btns.forEach(
      function(btn, index) {
        if (btn && btn.type && btn.type.displayName === 'ConfirmationButton') {
          newBtns.push(
            React.cloneElement(btn, {
              key: props.key || index,
              onClosed: props.onClosed,
              onClosing: props.onClosing,
              autoClose: props.autoClose,
              hide: props.hide
            })
          );
        } else if (isArray(btn)) {
          newBtns.push(wrappPopupButton.bind(this)(btn));
        }
      }.bind(this)
    );

    return newBtns;
  }

  Popup.Header = React.createClass({
    propsType: {
      title: React.PropTypes.string,
      tooltip: React.PropTypes.string,
      showCloseButton: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        title: '',
        tooltip: '',
        showCloseButton: true
      };
    },

    render: function() {
      var props = this.props;

      return (
        <div className='modal-header'>
          <h4 className={'modal-title u_floatLeft ' + props.type}>
            {props.title}
            {!isEmpty(props.tooltip) && (
              <a className='modal-tooltip'>
                <span className='icon-info-circled' title={props.tooltip} />
              </a>
            )}
          </h4>

          {props.showCloseButton && (
            <div className='pull-right'>
              <span className='icon-cancel' aria-label='Close' onClick={closePopup} />
            </div>
          )}
        </div>
      );

      function closePopup() {
        props.onClosing &&
          props.onClosing(function() {
            props.hide();
          }, 'cancel');
        props.onClosed && props.onClosed('cancel');
      }
    }
  });

  Popup.Body = React.createClass({
    propsType: {
      className: React.PropTypes.string
    },

    getDefaultProps: function() {
      return {
        className: ''
      };
    },

    render: function() {
      var className = classnames('modal-body', this.props.className);

      return <div className={className}>{this.props.children}</div>;
    }
  });

  Popup.Footer = React.createClass({
    render: function() {
      return <div className='modal-footer'>{wrappPopupButton.call(this, this.props.children)}</div>;
    }
  });

  Popup.ConfirmationButton = React.createClass({
    propTypes: {
      type: React.PropTypes.oneOf(['accept', 'cancel', 'close', 'custom']),
      disabled: React.PropTypes.bool
    },

    render: function() {
      return this.renderButton();
    },

    renderButton: function() {
      var disabled = this.props.disabled;
      var close = function() {
        this.props.hide();
      }.bind(this);

      var saveCancelProcess = function() {
        var type = this.props.type;
        if (this.props.autoClose) {
          close();
          this.props.onClosed && this.props.onClosed(type);
        } else {
          this.props.onClosing && this.props.onClosing(close, type);
        }
      }.bind(this);

      if (this.props.type === 'accept') {
        return (
          <button onClick={saveCancelProcess} type='button' className='btn btn-primary' disabled={disabled}>
            {this.props.children}
          </button>
        );
      } else if (this.props.type === 'cancel') {
        return (
          <button onClick={saveCancelProcess} type='button' className='btn btn-primary btn-report-default' disabled={disabled}>
            {this.props.children}
          </button>
        );
      } else if (this.props.type === 'close') {
        return (
          <a onClick={saveCancelProcess}>
            <span className='icon-cancel modal-close-button'>{this.props.children}</span>
          </a>
        );
      } else {
        return <Button {...this.props} />;
      }
    }
  });

  module.exports = Popup;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonPopup/Izenda.Popup.jsx